if (!customElements.get('subscription-drawer-block')) {
  class SubscriptionDrawerBlock extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('.js-open-subscription-drawer');
      this.drawerId = this.dataset.drawerId;

      if (!this.button || !this.drawerId) return;

      this.button.addEventListener('click', () => {
        const drawer = document.getElementById(this.drawerId);
        if (drawer) drawer.open(this.button);
      });
    }
  }

  customElements.define('subscription-drawer-block', SubscriptionDrawerBlock);
}
